import { type SWRResponse } from 'swr';

import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import type { AxiosKey } from '@/tsClient/servers/noodleApi';

const PATH = '/task-efficiencies';

export type TaskEfficiencyApi = ApiDefinition[typeof PATH]['GET'];

type Params = TaskEfficiencyApi['query'];

export const useTaskEfficiency = (
  params: Params | null,
  config?: UseNoodleSwrConfig<TaskEfficiencyApi['response']>,
): SWRResponse<TaskEfficiencyApi['response']> => {
  const key: AxiosKey | null = params ? [PATH, { params }] : null;
  return useNoodleSwr(key, { revalidateOnFocus: false, ...config });
};

/**
 * @deprecated: Please use `useTaskEfficiency` wherever a perfectly fresh response is not worth the network time, bandwidth, and compute.
 */
const getTaskEfficiency = async ({ referenceType, referenceId }: Params): Promise<TaskEfficiencyApi['response']> => {
  const response = await noodleApiClient.get(PATH, {
    params: { referenceId, referenceType },
  });
  return response.data as TaskEfficiencyApi['response'];
};

export default getTaskEfficiency;
